// src/utils/permissionUtils.js

/**
 * Converts a permission name from snake_case to Title Case.
 * e.g., "manage_batches" becomes "Manage Batches"
 * @param {string} permissionName The permission name in snake_case.
 * @returns {string} The permission name in Title Case.
 */
export const formatPermissionName = (permissionName) => {
  if (!permissionName) {
    return '';
  }
  return permissionName
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
